export default {
  init() {
    // JavaScript to be fired on all pages
    var mobileMenuBool = false;
    var mobileMenuBP = 1024;

    function mobileMenuInit() {
      if (window.matchMedia(`(max-width: ${mobileMenuBP}px)`).matches) {
        if (mobileMenuBool == false) {
          jQuery('.nav li.menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            jQuery(this).parent().addClass('sub-menu-open');
            jQuery(this).closest('ul').addClass('child-sub-menu-open');
          });

          jQuery('.nav > li.menu-item-has-children').each(function () {
            var btnHTML = '<li><button class="sub-menu-back-btn"><i class="fas fa-chevron-left mr-2"></i> Back</button></li>';

            if (jQuery(this).hasClass('menu-item-small') || jQuery(this).hasClass('columned-menu')) {
              jQuery(this).find('ul.sub-menu').prepend(btnHTML);
            } else {
              jQuery(this).find('> div.sub-menu-wrapper > ul.sub-menu').prepend(btnHTML);
            }
          });

          jQuery('button.sub-menu-back-btn').on('click', function (e) {
            e.stopPropagation();
            jQuery(this).closest('li.sub-menu-open').removeClass('sub-menu-open');
            jQuery(this).closest('ul.child-sub-menu-open').removeClass('child-sub-menu-open');
          });
          mobileMenuBool = true;
        }
      } else {
        if (mobileMenuBool == true) {
          jQuery('body').removeClass('menu-open');
          jQuery('.nav').find('.sub-menu-open').removeClass('sub-menu-open');
          jQuery('.nav').find('.child-sub-menu-open').removeClass('child-sub-menu-open');
          jQuery('.sub-menu-back-btn').parent().remove();

          if (jQuery('div.screen-overlay').hasClass('screen-overlay-visible')) {
            jQuery('div.screen-overlay').removeClass('screen-overlay-visible')
          }

          mobileMenuBool = false;
        }
      }
    }

    /* Mobile Menu Toggler */
    jQuery('.menu-toggler').click(function () {
      jQuery(this).toggleClass('open');
      jQuery('body').toggleClass('menu-open');
      jQuery('div.screen-overlay').toggleClass('screen-overlay-visible');

      if (jQuery(this).hasClass('open')) {
        jQuery('li.sub-menu-open').removeClass('sub-menu-open');
        jQuery('ul.child-sub-menu-open').removeClass('child-sub-menu-open');
      }

      /* remove open class from search if open */
      if (jQuery('.header-search').hasClass('open')) {
        jQuery('.header-search').removeClass('open');
      }
    });

    jQuery(window).ready(function () {
      mobileMenuInit();
    });

    jQuery(window).resize(function () {
      mobileMenuInit();
    });

    /* Makes screen overlay visible on top level nav link hover that has children */
    jQuery('.nav > li.menu-item-has-children').hover(
      function () {
        if (!window.matchMedia(`(max-width: ${mobileMenuBP}px)`).matches) {
          jQuery('div.screen-overlay').addClass('screen-overlay-visible');
        }
      }, function () {
        if (!window.matchMedia(`(max-width: ${mobileMenuBP}px)`).matches) {
          jQuery('div.screen-overlay').removeClass('screen-overlay-visible');
        }
      }
    );

    /* Search */
    const search = jQuery('.header-search');
    const searchInput = jQuery('.header-search__input');
    const searchToggle = jQuery('.header-search__toggle, .search-background-overlay');
    const searchBodyClass = 'menu-open-search';

    searchToggle.on('click', function () {
      search.toggleClass('open');
      search.hasClass('open') ? searchInput.focus() : searchInput.blur();
      if (search.hasClass('open')) {
        jQuery('body').addClass(searchBodyClass);
      } else {
        jQuery('body').removeClass(searchBodyClass);
      }

      if (jQuery('.menu-toggler').hasClass('open')) {
        jQuery('.menu-toggler').removeClass('open');
        jQuery('body').removeClass('menu-open');
        jQuery('div.screen-overlay').removeClass('screen-overlay-visible');
        jQuery('li.sub-menu-open').removeClass('sub-menu-open');
        jQuery('ul.child-sub-menu-open').removeClass('child-sub-menu-open');
      }
    });

    // Add smooth scrolling to all links
    jQuery('a').on('click', function (event) {

      console.log(this.hash);

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== '' && this.getAttribute('href').charAt(0) === '#' && jQuery(this).parent().attr('role') !== 'tab') {

        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        jQuery('html, body').animate({
          scrollTop: jQuery(hash).offset().top,
        }, 800, function () {

          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        });
      } // End if
    });

    jQuery('.copy-to-clipboard').on('click', function (event) {
      // Store input element
      var dummy = document.createElement('input'),
        // Get current URL
        text = window.location.href;
      // Append input element to body
      document.body.appendChild(dummy);
      // Assign current URL to inputs values
      dummy.value = text;
      // Select input
      dummy.select();
      // Copy inputs value to clipboard
      document.execCommand('copy');
      // Remove input
      document.body.removeChild(dummy);
      // Show success notice
      this.innerHTML = 'copied url';
      event.preventDefault();
    });

    jQuery('.export-csv').on('click', function (event) {
      // Get current URL
      var url = window.location.href;
      // Extra query string
      var filterQueries = url.split('/').pop();
      // Get current term ID from data attribute
      var term = this.getAttribute('data-term-id');
      // Define term query string
      var termQuery = '';
      if (filterQueries.length > 0) {
        termQuery = '&_used_cat=' + term;
      } else {
        termQuery = '?_used_cat=' + term;
      }
      console.log(window.location.origin + '/csv-exporter/' + filterQueries + termQuery);
      // Redirect browser to CSV exporter
      window.location.href = window.location.origin + '/csv-exporter/' + filterQueries + termQuery;
      event.preventDefault();
    });

    const couponFormToggle = document.querySelector('[data-show-coupon-form]');
    if (couponFormToggle) {
      couponFormToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.target.style.display = 'none';
        document.querySelector('.coupon').classList.add('show');
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    /* Submit form on filter value change */
    jQuery('select.filter').on('change', function () {
      jQuery(this).closest('form').submit();
    });

    /* Category Term List */
    var catListHiddenItem = jQuery('.category-list__item-hidden');
    var catListShowmore = jQuery('.category-list__showmore');

    /* Show more/Show Less categories on click as well as changing button text */
    catListShowmore.on('click', function () {
      jQuery(this).text() == 'Show more' ? jQuery(this).text('Show Less') : jQuery(this).text('Show more');
      catListHiddenItem.toggleClass('category-list__item-hidden category-list__item-show');
    });

    jQuery('.accordion__toggle').on('click', function () {
      jQuery(this).parent().toggleClass('open');
      jQuery(this).next().slideToggle(300);
    });

    /* eslint-disable */
    /* Add event on FacetWP hook to scroll to top of listing */
    jQuery(document).on('facetwp-loaded', function () {
      if (FWP.loaded) {
        jQuery('html, body').animate({
          scrollTop: jQuery('#top.hidden-anchor').offset().top,
        }, 500);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js